<div class="title">
  <h1>{{'Upload Forms'  | translate | async}}</h1>
</div>

<div style="margin-left: 10%;margin-right: 10%;">

  <!-- <div *ngIf="isLoading ==true" style="display: flex;flex-direction: column;align-items: center;
  justify-content: center;left: 50%; position: absolute;top: 40%;">
        <mat-spinner></mat-spinner>
      </div> -->

  <div style="display: flex;" class="sc-row-margin">
    <div style="flex: 1">
      <h4 style="font-weight: bold; font-size: 18px;" class="get-label">{{'State' | translate | async}}<span style="color: red;font-size: 15px;">*</span></h4>
      <mat-form-field style="width: 400px">
        <mat-select [(ngModel)]="inputValuestate" name="Site" [formControl]="state" required>
          <mat-option *ngFor="let Site of siteCodesList" [value]="Site.Id">
            {{Site.SiteName}}
          </mat-option>
        </mat-select>
        <mat-error *ngIf="state.invalid">{{getErrorMessage()}}</mat-error>
      </mat-form-field>
    </div>

    <div style="flex: 1">
      <mat-label style="font-weight: bold; font-size: 18px;" class="get-label">{{'Date Completed' | translate | async}}<span style="color: red;font-size: 15px;">*</span></mat-label>
      <mat-form-field appearance="DBSS" style="width: 400px;">
        <input matInput [matDatepicker]="picker1" type="picker1" [(ngModel)]="dateCompleted" [ngModelOptions]="{standalone: true}" required [max]="today">
        <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
        <mat-datepicker #picker1></mat-datepicker>
      </mat-form-field>
    </div>

    <div style="flex: 1;">
      <div class="sc-input-label-2" style="width: 400px;">
        <div class="example-full-width" style="width: 500px;display: flex; flex-direction: row; justify-content: flex-start;">
          <div class="addfiles">
            <ng-container *ngFor="let file of FileList; let indx = index">
              <div *ngIf="getFileType(file) == 'pdf'">
                <mat-icon title="{{getFileType(file)}}" (click)="DownloadForm(indx)">picture_as_pdf</mat-icon>
              </div>
              <img *ngIf="getFileType(file) != 'pdf'" style="padding-bottom: 3px;" src="../../../../../../Content/Images/Icons/icons_file-24.png" alt="File" title="{{getFileType(file)}}">
            </ng-container>
          </div>

          <div class="sc-icon">
            <mat-label style="font-weight: bold; font-size: 18px;" class="get-label">+ {{'Add File(s)' | translate | async}} </mat-label> (.pdf, .docx, .xls)
            <input type="file" #fileUploader name="upload" accept="application/pdf,application/vnd.ms-excel" (change)="onFileChanged($event);" multiple>
          </div>
        </div>
      </div>

    </div>

  </div>

  <div style="display: flex;" class="sc-row-margin">
    <div style="flex: 1">
      <h4 style="font-weight: bold; font-size: 18px;" class="get-label">{{'Form' | translate | async}}<span style="color: red;font-size: 15px;">*</span></h4>
      <mat-form-field appearance="DBSS" style="width: 400px;">
        <mat-select matNativeControl [(ngModel)]="inputForm" required>
          <mat-optgroup *ngFor="let formCat of groupedForms" [label]="formCat.FormCategoryName">
            <mat-option *ngFor="let form of formCat.Forms" [value]="form.Id" (click)="ClickForm(formCat)">
              {{form.Name}}
            </mat-option>
          </mat-optgroup>
        </mat-select>
      </mat-form-field>
    </div>
    <div style="flex: 1">
      <div style="border-top: 0;">
        <div style="display: flex;">
          <div class="sc-input-label-1" style="flex: 1.07;font-weight: bold; font-size: 18px;">{{'Related User' | translate | async}}</div>
          <div class="sc-icon" style="padding-left: 170px; flex: 1; display: flex;" (click)="GetAdminLinkToAddUsers()">
            <i class="material-icons">add</i>
            <span style="padding-left: 8px;">{{'Add User' | translate | async}}</span>
          </div>
        </div>
        <mat-form-field style="width: 400px;">
          <mat-select [(ngModel)]="relatedUser">
            <mat-option *ngFor="let usr of users" [value]="usr.UserAuto">{{usr.UserName}}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>


    <div style="flex: 1">
      <div style="display: flex;">
        <!-- <div class="sc-input-label-1" style="flex: 1">Images</div> -->
        <!-- <ng-container *ngIf="ImageList.length>0"> -->
        <ng-container *ngFor="let img of ImageList">
          <img style="width:100px; height:100px; padding: 4px;" *ngIf="img" [src]="sanitize(img)">
          <!-- <img style="width:100px; height:100px" *ngIf="ImageList" [src]="sanitize(ImageList)"> -->
        </ng-container>
        <!-- </ng-container> -->
        <div class="sc-icon" style="padding-left: 20px;">
          <span style="font-weight: bold; font-size: 18px;">+ {{'Add Image(s)' | translate | async}} </span> (.png, .jpg, .jpeg)
          <input type="file" #fileUploader_ accept="image/*" (change)="onSelectPhoto($event)" multiple>
        </div>
      </div>
      <div style="display: flex; flex-wrap: wrap">
      </div>
    </div>


  </div>
  <ng-container *ngIf="isRequireIncidentNo==true">
    <div style="display: flex" class="sc-row-margin">
      <div style="flex: 1">
        <h4 style="font-weight: bold; font-size: 18px;" class="get-label">{{'Report/Incident ID' | translate | async}}<span style="color: red;font-size: 15px;">*</span></h4>
        <mat-form-field style="width: 400px;">
          <input matInput [(ngModel)]="reportIncidentID" required>
        </mat-form-field>
      </div>

      <div style="flex: 1">
        <h4 style="font-weight: bold; font-size: 18px;" class="get-label">{{'Incident Type' | translate | async}}</h4>
        <mat-form-field style="width: 400px;">
          <mat-select [(ngModel)]="incidentType">
            <mat-option *ngFor="let iType of incidentTypes" [value]="iType.Id">
              {{iType.Name}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <div style="flex: 1">
      </div>
    </div>
  </ng-container>
  <div style="display: flex;" class="sc-row-margin">
    <div style="flex: 1">
      <h4 style="font-weight: bold; font-size: 18px;" class="get-label">{{'Notes' | translate | async}}</h4>
      <mat-form-field style="width: 1000px; ">
        <textarea class="sc-textarea" matInput [(ngModel)]="Notes" [ngModelOptions]="{standalone: true}"></textarea>
      </mat-form-field>
    </div>
  </div>


  <div style="display: flex" class="sc-row-margin">
    <div style="flex: 1">
      <div style="display: flex; font-weight: bold; font-size: 18px;">
        <mat-checkbox [(ngModel)]="isActiveFollowUpRequired">{{'Follow Up Required' | translate | async}}</mat-checkbox>
      </div>
    </div>

    <div style="flex: 1">
      <div style="display: flex;font-weight: bold; font-size: 18px;">
        <mat-checkbox [(ngModel)]="isActiveFollowUpCompleted">{{'Follow Up Completed' | translate | async}}</mat-checkbox>
      </div>
    </div>
    <div style="flex: 1">
    </div>
  </div>

  <div style="display: flex;padding-top: 1.25em;" class="sc-row-margin">

    <div style="flex: 1">
      <mat-label style="font-weight: bold; font-size: 18px;" class="get-label">{{'Follow Up Date' | translate | async}}<span style="color: red;font-size: 15px;">*</span></mat-label>
      <mat-form-field appearance="DBSS" style="width: 400px;">
        <!-- <mat-label>Date Completed</mat-label> -->
        <input matInput [matDatepicker]="picker2" type="picker2" [(ngModel)]="fololowupDate" [ngModelOptions]="{standalone: true}" required>
        <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
        <mat-datepicker #picker2></mat-datepicker>
      </mat-form-field>
    </div>


    <div style="flex: 1">
      <div style="border-top: 0;">
        <div style="display: flex;">
          <div class="sc-input-label-1" style="flex: 1;font-weight: bold; font-size: 18px;">{{'Follow Up User'  | translate | async}}</div>
          <div class="sc-icon" style="padding-left: 170px; flex: 1; display: flex;" (click)="GetAdminLinkToAddUsers()">
            <i class="material-icons">add</i>
            <span style="padding-left: 8px;">{{'Add User'| translate | async}}</span>
          </div>
        </div>
        <mat-form-field style="width: 400px;">
          <mat-select [(ngModel)]="fololowupUser">
            <mat-option *ngFor="let usr of users" [value]="usr.UserAuto">{{usr.UserName}}</mat-option>
          </mat-select>
          <!-- <i class="material-icons" (click)="GetAdminLinkToAddUsers()">add</i> -->
        </mat-form-field>
      </div>
    </div>
    <div style="flex: 1">
    </div>
  </div>
  <div class="loader-wrapper" *ngIf="savingForm">
    <mat-spinner></mat-spinner>
    </div>
  <div style="display: flex" class="sc-row-margin">
    <div style="flex: 1">
    </div>
    <div>
      <div style="display: flex;">
        <div class="buttonbelow">
          <button mat-raised-button (click)="reload()">{{"Reset" | translate | async}}</button>
          <button mat-raised-button color="warn" (click)="AddCompletedFormWithState()" >{{'Save' | translate | async}}</button>
          <ng-container *ngIf="checkIsAdmin==true && UploadFormId>0">
            <button mat-raised-button (click)="Delete()">{{'Delete' | translate | async}}</button>
          </ng-container>
        </div>
      </div>
    </div>
  </div>
  <!-- <div *ngIf="isLoading ==true" style="display: flex;flex-direction: column;align-items: center;
  justify-content: center;min-height: 500px;align-self: center;">
        <mat-spinner></mat-spinner>
      </div> -->
</div>
